import { Details } from "@mui/icons-material"
import BatchChangeDatasource from "data/dataSource/Common/BatchChangeDataSource"
import { Auth } from "domain/model/Auth"

import { BatchChangeRepository } from "domain/repository/Common/BatchChangeRepository"

export class BatchChangeRepositoryImpl implements BatchChangeRepository {
  private dataSource: BatchChangeDatasource

  constructor(dataSource: BatchChangeDatasource) {
    this.dataSource = dataSource
  }
  GetAllbatchesDetails(auth: Auth, page: any, limit: any): Promise<any> {
    return this.dataSource.GetallBatchesDetails(auth, page, limit)
  }
  GetbatchDetails(auth: Auth, name: string): Promise<any> {
    return this.dataSource.GetBatchDetails(auth, name)
  }
  UpdatebatchesDetails(auth: Auth, Batchid: string, batch: any): Promise<any> {
    return this.dataSource.UpdatebatchDetails(auth, Batchid, batch)
  }
  GetbatchStatus(auth: Auth, batchid: string): Promise<any> {
    return this.dataSource.GetBatchStatus(auth, batchid)
  }
  GetbatchStudents(auth: Auth, batchid: string): Promise<any> {
    return this.dataSource.GetBatchStudents(auth, batchid)
  }
}
